import { onMounted, ref } from '@nuxtjs/composition-api';

import { convert, format, toTokensNormalised } from './helpers';
import { Units } from './types';

const DEFAULT_UNIT = Units.CM;

const units = ref<Units>(DEFAULT_UNIT);

const useUnitConversion = () => {
  const listUnits = () => Units;

  const toUnits = (str: string | undefined): Units | undefined => {
    if (str?.match(/cm\b/i)) return Units.CM;
    if (str?.match(/inche?s?\b/i)) return Units.INCH;
  };

  const setUnits = (unitsTo: string) => (units.value = toUnits(unitsTo) ?? Units.CM);

  const convertUnits = (value: string, unitsFrom: Units | undefined) => {
    if (unitsFrom === units.value) return value;
    return toTokensNormalised(value)
      .map(convert(unitsFrom, units.value))
      .map(format(units.value))
      .join(' ');
  };

  onMounted(() => {
    units.value = DEFAULT_UNIT;
  });

  return {
    units,
    listUnits,
    toUnits,
    setUnits,
    convertUnits,
  };
};

export default useUnitConversion;
